import {openGuestConfigSection} from '../ioPass/adapter';

/**
 * Canvas IO-Pass > Configuration.
 *
 * Guest access setup: the splash pages shown to guests and the
 * administrator email approval flow. The two lists on this tab are resources
 * of their own - Captive Portals and Guest Access Plans both have a search
 * box, an Add button and per-row Edit and Delete, which is a record
 * collection rather than a section - so this plugin owns the tab itself and
 * they own their own lists. Splash Pages and Admin Email Approval are still
 * unmapped, so the agent opens the tab and does not claim to act on them.
 */
const guestConfigPlugin = {
	id: 'guest_config',
	version: 1,
	commandVersion: 1,
	resource: 'guest_config',
	operations: ['view'],
	dependencies: {
		plugins: ['canvas.navigation'],
		destinations: ['iopass.dashboard'],
	},
	sections: {
		'iopass.guest_config': openGuestConfigSection,
	},
};

export default guestConfigPlugin;
